module.exports = __webpack_public_path__ + "static/img/license.3afeb62.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/license.png
// module id = c2IF
// module chunks = 1